import { render } from "./TablePlaceholder.vue?vue&type=template&id=8bfd4376&scoped=true"
import script from "./TablePlaceholder.vue?vue&type=script&lang=js"
export * from "./TablePlaceholder.vue?vue&type=script&lang=js"

import "./TablePlaceholder.vue?vue&type=style&index=0&id=8bfd4376&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bfd4376"]])

export default __exports__